import { render, staticRenderFns } from "./NewOrderNotFOBAlert.vue?vue&type=template&id=2c06cdd4&"
import script from "./NewOrderNotFOBAlert.vue?vue&type=script&lang=js&"
export * from "./NewOrderNotFOBAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports